import React, { useEffect } from "react";
import { Text } from "@origin-digital/ods-core";
import { AlertPopper } from "@origin-digital/ods-lab";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { bindPopper, usePopupState } from "material-ui-popup-state/hooks";

interface PropertyPopperProps {
  id: string;
  anchorEl: HTMLElement | null;
}

export const LOCAL_STORAGE_KEY_POPPER = "hide-action-bar-popper";

export const PropertyPopper = ({ id, anchorEl }: PropertyPopperProps) => {
  const popupState = usePopupState({ variant: "popper", popupId: id });
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    const actionBarStorage = localStorage.getItem(LOCAL_STORAGE_KEY_POPPER);
    if (!actionBarStorage) {
      popupState.open(anchorEl);
    }
  }, [anchorEl]);

  const onClose = () => {
    popupState.close();
    localStorage.setItem(LOCAL_STORAGE_KEY_POPPER, "true");
  };

  return (
    <AlertPopper
      title="Multiple properties?"
      placement={desktop ? "bottom" : "bottom-end"}
      onClose={onClose}
      muiProps={{
        disablePortal: true,
        style: { margin: "-8px 16px 0 16px", maxWidth: "250px" },
      }}
      {...bindPopper(popupState)}
    >
      <Text>You can switch between properties using this drop-down menu.</Text>
    </AlertPopper>
  );
};
